import { Auction } from '@/fairplayer/domain/exclusive/Auction';
import { AuctionStatus } from '@/fairplayer/domain/exclusive/AuctionStatus';

export interface BackendAuction {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  status: AuctionStatus;
  visible: boolean;
  anonymous: boolean;
}

export const toAuction = (backendAuction: BackendAuction): Auction => ({
  id: backendAuction.id,
  name: backendAuction.name,
  startDate: new Date(backendAuction.startDate),
  endDate: new Date(backendAuction.endDate),
  status: backendAuction.status,
  anonymous: backendAuction.anonymous,
});
